import Button from '@mui/material/Button'
import Step from '@mui/material/Step'
import StepContent from '@mui/material/StepContent'
import StepLabel from '@mui/material/StepLabel'
import Stepper from '@mui/material/Stepper'
import { useParams } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  selectActiveStep,
  selectSessionByID,
  steppedBackward,
  steppedForward,
} from '../live.slice'

export default () => {
  let dispatch = useAppDispatch()
  let activeStep = useAppSelector(selectActiveStep)
  let { sessionID } = useParams()
  let session = useAppSelector(selectSessionByID(sessionID ?? ''))

  return (
    <>
      <Stepper
        activeStep={activeStep}
        orientation="vertical"
        style={{ backgroundColor: 'inherit' }}
      >
        <Step>
          <StepLabel>{session?.className}</StepLabel>
          <StepContent>
            <div>
              <div>
                <Button
                  disabled={activeStep === 0}
                  onClick={() => dispatch(steppedBackward())}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => dispatch(steppedForward())}
                >
                  Quiz
                </Button>
              </div>
            </div>
          </StepContent>
        </Step>
        <Step>
          <StepLabel>Quiz</StepLabel>
          <StepContent>
            <div>
              <div>
                <Button onClick={() => dispatch(steppedBackward())}>
                  Back
                </Button>
              </div>
            </div>
          </StepContent>
        </Step>
      </Stepper>
    </>
  )
}
